/**
 * Default color palette for Kanban pipeline stages.
 * Keep in sync with: app/services/kanban/pipeline_management_service.rb (DEFAULT_STAGE_COLORS)
 */
export const KANBAN_STAGE_COLORS = [
  '#3b82f6',
  '#06b6d4',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#ec4899',
  '#6366f1',
  '#14b8a6',
  '#f97316',
  '#84cc16',
  '#0ea5e9',
  '#a855f7',
  '#22c55e',
  '#eab308',
];
